// extracted by css-extract-rspack-plugin
export default {"cls1":"SnackBar-cls1_CzV","cls2":"SnackBar-cls2_2CC SnackBar-cls1_CzV"};